import React, { useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import { useFlags, withLDProvider } from "launchdarkly-react-client-sdk";

import AppProvider from "./context/index";

import MyTransactions from "./containers/MyTransactions/index";
import i18next from "./i18n/index";

const getLDRelayURL = () => {
  let env = "";
  const smilesDomain = window.location.hostname.indexOf("smiles.com.br") > -1;
  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const isDotEnv = /^voebiz\.(.+)\.smiles\.com\.br$/.test(window.location.hostname);
  const res = rx.exec(window.location.hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      // eslint-disable-next-line prefer-destructuring
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, "").replace("uat", "hml");
    env = isDotEnv ? `.${env}` : `${env}`;
  }
  if (window.location.hostname === "localhost") {
    env = "-hml5";
  }
  return `https://ldrelay${env}.smiles.com.br`;
};
const clientSideId = "62baf3989195871574e35e6c";
const launchDarklyURL = getLDRelayURL();
function App() {
  const [loading, setLoading] = useState(true);
  const { apiDomain } = useFlags();
  useEffect(() => {
    if (apiDomain) {
      setLoading(false);
    }
  }, [apiDomain]);
  if (loading) {
    return <div />;
  }
  return (
    <div className="vbz-lf">
      <AppProvider>
        <I18nextProvider i18n={i18next}>
          <MyTransactions />
        </I18nextProvider>
      </AppProvider>
    </div>
  );
}
export default withLDProvider({
  clientSideID: clientSideId,
  user: { key: window.location.origin },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App);
